import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

function LanguageModal({
  showLanguageModal,
  handleLanguageModalClose,
  languageOptions,
  languageTranslations,
}) {
  return (
    <Modal
      open={showLanguageModal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: "15px",
          // boxShadow: 24,
          p: 3,
          bgcolor: "#333", // Change to your preferred dark color
          color: "white", // Set text color to white
          width: "85%",
          "@media (min-width:600px)": {
            width: "40%",
            maxWidth: "500px",
          },
        }}
      >
        <Typography
          textAlign="center"
          id="modal-modal-title"
          variant="h6"
          component="h2"
          marginBottom={2}
        >
          Language (ഭാഷ)
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            "@media (min-width:600px)": {
              flexDirection: "column",
            },
          }}
        >
          {Object.values(languageOptions).map((language) => (
            <Button
              key={language}
              onClick={() => handleLanguageModalClose(language)}
              variant="contained"
              color="primary"
              style={{
                textTransform: "capitalize",
                fontSize: "1.2rem",
                width: "80%",
                margin: "auto",
              }}
            >
              {language === "english"
                ? `${language.charAt(0).toUpperCase() + language.slice(1)}`
                : `${language.charAt(0).toUpperCase() + language.slice(1)} // ${
                    languageTranslations[language]
                  }`}
            </Button>
          ))}
        </Box>
      </Box>
    </Modal>
  );
}

export default LanguageModal;
